import {createWithEqualityFn} from 'zustand/traditional';
import {immer} from 'zustand/middleware/immer';
import {ZipValidationState} from '@components/Sku/ZipCodeEntry/ZipCodeEntry';

/* ----------------------------------------------------------------------- */
/* ---------------------  TYPES  ----------------------------------------- */
/* ----------------------------------------------------------------------- */
export type Modals = {
  [key: string]: {visible: boolean} & Record<string, unknown>;
};

export type ServiceSkuState = {
  zipCodeGate: {
    isZipSuccessViewActive: boolean;
    zipValidationState: ZipValidationState | null;
    setZipSuccessViewActive: (arg: boolean) => void;
    setZipValidationState: (arg: ZipValidationState | null) => void;
  };
};

/* ----------------------------------------------------------------------- */
/* ----------------  SERVICE SKU STORE SETUP  ---------------------------- */
/* ----------------------------------------------------------------------- */
const useServiceSkuStore = createWithEqualityFn<ServiceSkuState>()(
  immer(set => ({
    zipCodeGate: {
      isZipSuccessViewActive: false,
      zipValidationState: null,

      /* Actions */
      setZipSuccessViewActive: (setSuccess: boolean = false) =>
        set((state: ServiceSkuState) => {
          state.zipCodeGate.isZipSuccessViewActive = setSuccess;
        }),
      setZipValidationState: (setZipStatus: ZipValidationState  | null) =>
        set((state: ServiceSkuState) => {
          state.zipCodeGate.zipValidationState = setZipStatus;
        }),
    },
  })),
);

export default useServiceSkuStore;
